import request from "@/utils/request"
/**
 * 获取广告图
 * @returns Promise
 */

//获取课程详情
export const findVideoDetail = (id) => {
  return request('/video/detail', 'get', { id })
}

//获取视频推荐（有clID的情况下）
export const findVideoRecommand = (clID) => {
  return request('/video/recommend', 'get', { clID })
}


//获取随机视频(没有clID的情况下)
export const findVideoRandom = (limit) => {
  return request('/video/random', 'get', { limit })
}


//获取video视频
export const findLesson = ({ maID, chID, coID, clID, page, size }) => {
  return request('/video/lesson', 'get', { maID, chID, coID, clID, page, size })
}

export const findVideoPlay = (id) => {
  return request('/video/play', 'get', { id })
}

//测试获取视频目录
/* export const findVideoContent = (conID) => {
  return request('/video/content', 'get', { conID })
} */

//获取点击考试大纲详情
export const findOutlineView = (lineID) => {
  return request('/video/lineview', 'get', { lineID })
}

//获取点击备考指导详情
export const findAdviceView = (advID) => {
  return request('/video/adviceview', 'get', { advID })
}


export const findVideoCheckOut = (id) => {
  return request('/video/checkout', 'get', { id })
}

